export { PromotionIcon } from "./PromotionIcon";
